const api = process.env.REACT_APP_STO_URL

export const FaceBot = `${api}/images/photofacebot`

export const BotSmile = `${api}/images/botsmile`

export const BotIcon = `${api}/images/boticon`

export const BotName = `${api}/images/botname`

export const LogoLightMode = `${api}/images/logolightmode`

export const LogoDarkMode = `${api}/images/logodarkmode`

export const MiddleBodyBot = `${api}/images/botmiddlebody`